import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const useClaimableCreatorFees = () => {
    const { account } = useWeb3React();

    const { sdk } = useContext(appContext);

    const { data, error } = useSWR(
        sdk && account ? ['claimableCreatorFees', account] : null,
        (_, userAddress) => sdk!.fees.getCreatorFeesClaimable(userAddress!)
    );

    return {
        claimableCreatorFees: data,
        isLoading: !error && !data,
        error,
    };
};

export default useClaimableCreatorFees;
